import React from 'react';
import { Box, Typography, Container, Grid, Card, CardContent, Stack, Button } from '@mui/material';
import { motion } from 'framer-motion';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import PersonIcon from '@mui/icons-material/Person';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CallIcon from '@mui/icons-material/Call';

const ContactSection = () => {
  const deepGolden = "#B8860B";
  const softSaffron = "#FFF8E1";
  const brightSaffron = "#FF8C00";
  const lightBg = "linear-gradient(180deg, #FFFFFF 0%, #FFF9F0 100%)";

  const mapUrl = "https://maps.google.com"; 
  const emailAddress = "info@jinbhakti.com";
  const whatsAppNumber = "919561339050"; 
  const mainContactNumber = "+919561339050"; 

  const contactCards = [
    { 
      icon: <LocationOnIcon />, 
      title: "मुख्य कार्यालय", 
      detail: "जैन मंदिर जवळ, सांगवडेवाडी.",
      action: "नकाशा पहा",
      link: mapUrl,
    },
    { 
      icon: <PersonIcon />, 
      title: "प्रमुख मार्गदर्शक", 
      isList: true,
      people: [
        { name: "प्र.पं. श्री दीपक उपाध्ये (कळंबी)", phone: "+91 9561339050" },
        { name: "पं. श्री अभयकुमार उपाध्ये (सांगवडेवाडी)", phone: "+91 9822339632" },
        { name: "पं. श्री ऋषभनाथ उपाध्ये (समडोळी)", phone: "+91 9765326764" }
      ],
      action: "संपर्क करा",
      link: `tel:${mainContactNumber}`
    },
    { 
      icon: <WhatsAppIcon />, 
      title: "व्हॉट्सअ‍ॅप", 
      detail: "अपडेट्स मिळवण्यासाठी मेसेज करा.",
      action: "चॅट करा",
      link: `https://wa.me/${whatsAppNumber}`,
      type: 'whatsapp'
    },
    { 
      icon: <EmailIcon />, 
      title: "ईमेल पत्ता", 
      detail: "info@jinbhakti.com",
      action: "मेल पाठवा",
      link: `mailto:${emailAddress}`,
    }
  ];

  return (
    <Box sx={{ py: { xs: 6, md: 10 }, background: lightBg, overflow: 'hidden' }}>
      <Container maxWidth="lg">
        
        <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 6 } }}>
          <motion.div initial={{ opacity: 0, y: -20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <Typography variant="overline" sx={{ color: deepGolden, fontWeight: 800, letterSpacing: 2, display: 'block' }}>
              नमो जिणाणं
            </Typography>
            <Typography variant="h3" sx={{ fontWeight: 900, fontSize: { xs: '2rem', md: '3rem' }, color: '#2d2d2d' }}>
              आमच्याशी <span style={{ color: brightSaffron }}>संपर्क</span> साधा
            </Typography>
            <Box sx={{ width: '50px', height: '4px', bgcolor: brightSaffron, mx: 'auto', mt: 1.5, borderRadius: 2 }} />
          </motion.div>
        </Box>

        {/* alignItems काढून टाकल्यामुळे आता उंची मजकुरानुसार राहील */}
        <Grid container spacing={3} justifyContent="center">
          {contactCards.map((card, index) => (
            <Grid item xs={12} sm={6} md={card.isList ? 6 : 3} key={index}> 
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <Card sx={{ 
                  borderRadius: '20px', 
                  border: '1px solid rgba(255, 140, 0, 0.12)',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
                  transition: '0.3s',
                  '&:hover': { transform: 'translateY(-5px)', borderColor: brightSaffron }
                }}>
                  <CardContent sx={{ p: 2.5, textAlign: 'center' }}>
                    
                    <Box sx={{ 
                      width: '50px', height: '50px', 
                      bgcolor: card.type === 'whatsapp' ? '#E8F5E9' : softSaffron, 
                      color: card.type === 'whatsapp' ? '#2E7D32' : brightSaffron,
                      borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', 
                      mx: 'auto', mb: 1.5, '& svg': { fontSize: 26 }
                    }}>
                      {card.icon}
                    </Box>

                    <Typography variant="h6" sx={{ fontWeight: 800, mb: 1.5, fontSize: '1.05rem' }}>
                      {card.title}
                    </Typography>

                    <Box sx={{ mb: 2 }}>
                      {card.isList ? (
                        <Stack spacing={1}>
                          {card.people.map((person, pIndex) => (
                            <Box key={pIndex} sx={{ 
                              p: 1, bgcolor: '#fdfdfd', borderRadius: '10px', border: '1px solid #f0f0f0', textAlign: 'left'
                            }}>
                              <Typography sx={{ fontWeight: 700, fontSize: '0.8rem', color: '#333' }}>{person.name}</Typography>
                              <Typography sx={{ color: deepGolden, fontSize: '0.75rem', fontWeight: 600 }}>{person.phone}</Typography>
                            </Box>
                          ))}
                        </Stack>
                      ) : (
                        <Typography variant="body2" sx={{ color: '#666', fontSize: '0.85rem', lineHeight: 1.5 }}>
                          {card.detail}
                        </Typography>
                      )}
                    </Box>
                    
                    <Button
                      variant="contained"
                      href={card.link}
                      fullWidth
                      startIcon={card.isList ? <CallIcon /> : null}
                      sx={{ 
                        bgcolor: card.type === 'whatsapp' ? '#25D366' : brightSaffron,
                        borderRadius: '50px', fontWeight: 700, textTransform: 'none', fontSize: '0.85rem',
                        py: 0.7,
                        '&:hover': { bgcolor: card.type === 'whatsapp' ? '#128C7E' : deepGolden }
                      }}
                    >
                      {card.action}
                    </Button>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>

      </Container>
    </Box>
  );
};

export default ContactSection;